import { Outlet, Link } from "react-router-dom";

const menu ={
  textAlign: 'right',
}


const Layout = () => {
  return (
    <>
      <nav style={menu}>
        
          
        
      </nav>

      <Outlet />
    </>
  )
};


//<Link to="/">Home</Link>
//<Link to="/pages/Millennium">Millennium</Link>
//<Link to="/pages/PKOBP">PKOBP</Link>
//<Link to="/pages/BNPParibas">BNP Paribas</Link>
 


export default Layout;